var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full flex flex-col md:flex-row"},[_c('div',{staticClass:"w-full md:w-3/5 flex mb-5"},[_c('AbsensiBuat')],1),_c('div',{staticClass:"w-full md:w-2/5 md:ml-base"},[_c('AbsensiRiwayat')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }